var map = {
	"./by.png": 827,
	"./kz.png": 828,
	"./md.png": 829,
	"./ot.png": 830,
	"./ru.png": 831,
	"./ua.png": 832,
	"./us.png": 833,
	"./uz.png": 834
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 826;